export const skillsData = {
  languages: ["Python", "TypeScript", "JavaScript", "C", "C++", "MATLAB", "Java"],
  software: ["SolidWorks", "Siemens NX", "CREO", "Onshape", "CATIA", "ANSYS", "StarCCM+", "Abaqus CAE", "GOM Correlate", "Claude Code", "Cursor"],
  concepts: ["FEA", "CFD", "GD&T & Tolerance Stack-up", "DIC / Optical Strain Measurement", "Camera Calibration", "B-basis Design Allowables", "Structure Mechanics", "Composite Materials", "LLM APIs & Prompt Design"],
  spoken: ["English", "Tamil", "Hindi", "French"]
};
